import { render, staticRenderFns } from "./dynamicForm.vue?vue&type=template&id=384fcbcc&scoped=true&"
import script from "./dynamicForm.vue?vue&type=script&lang=js&"
export * from "./dynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./dynamicForm.vue?vue&type=style&index=0&id=384fcbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fcbcc",
  null
  
)

export default component.exports